import type { FormHeaderFooterExit } from './FormVariant/types';
import type {
  HeaderFooterLayoutConfig,
  HeaderFooterLayoutVariant,
  HeaderFooterTheme,
} from './types';

export interface ResolvedHeaderFooterLayoutConfig {
  variant: HeaderFooterLayoutVariant;
  theme: HeaderFooterTheme;
  exit?: FormHeaderFooterExit;
}

// Deeper layouts override shallower ones, so pass them root first
export const resolveHeaderFooterLayoutConfig = (
  layouts: (HeaderFooterLayoutConfig | undefined)[],
): ResolvedHeaderFooterLayoutConfig =>
  layouts.reduce<ResolvedHeaderFooterLayoutConfig>(
    (acc, layout) => ({ ...acc, ...layout }),
    { exit: undefined, theme: 'white', variant: 'form' },
  );
